<template>
  <div class="sensor" v-click-outside="hideMinMaxSetup">
    <div class="sensor__value" :class="valueColor">{{sensor.measurement !== null ? sensor.measurement.toFixed(2) : 'N/A'}}{{sensor.measurement !== null ? sensor.unit : ''}}</div>
    <div class="sensor__limit-values" :class="{active: showMinMaxSetup}">
      <div @click="toggleMinMaxSetup">
        <div class="sensor__limit-values__max">
          <span>Max:</span>
          {{ maxCritFormatted }}
        </div>
        <div class="sensor__limit-values__min">
          <span>Min:</span>
          {{ minCritFormatted }}
        </div>
      </div>
      <transition name="fadeUp">
        <SensorSetup
          v-if="showMinMaxSetup"
          :sensor="sensor"
          @onChange="updateCriticalValues"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import SensorSetup from '@/components/SensorSetup.vue';

export default {
  name: 'Sensor',
  components: {
    SensorSetup,
  },
  props: {
    sensor: {
      type: Object,
      // validator: obj => Object.keys(obj).every(field => ['id', 'measurement', 'unit', 'minCrit', 'maxCrit', 'minValue', 'maxValue'].includes(field)),
      required: true,
    },
  },
  data() {
    return {
      showMinMaxSetup: false,
    };
  },
  computed: {
    valueColor() {
      if (this.sensor.measurement >= this.sensor.maxCrit) {
        return 'over-max';
      } if (this.sensor.measurement <= this.sensor.minCrit) {
        return 'below-min';
      }

      return '';
    },
    minCritFormatted(){
      let crit = this.sensor.minCrit > 1000 ? this.sensor.minCrit / 1000 : this.sensor.minCrit;
      let label = this.sensor.minCrit > 1000 ? 'k' : '';
      return Math.ceil(crit) + label + this.sensor.unit ;
    },
    maxCritFormatted(){
      let crit = this.sensor.maxCrit > 1000 ? this.sensor.maxCrit / 1000 : this.sensor.maxCrit;
      let label = this.sensor.maxCrit > 1000 ? 'k' : '';
      return Math.ceil(crit) + label + this.sensor.unit ;
    }
  },
  methods: {
    toggleMinMaxSetup() {
      this.showMinMaxSetup = !this.showMinMaxSetup;
    },
    hideMinMaxSetup() {
      this.showMinMaxSetup = false;
    },
    async updateCriticalValues(request) {
      this.$store.dispatch('tentacle/updateSensors', [request]).then((response) => {
        this.flash('Sensor updated', 'success');
        // add errr flash handler
      });
      this.showMinMaxSetup = false;
    },

  },
};
</script>

<style lang="scss" scoped>
.sensor {
  flex-grow: 1;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: 0.5px;

  &__value {
    font-size: 1.4rem;
    font-weight: 500;
    color: $company-color;

    &.below-min {
      color: $min-color;
    }
    &.over-max {
      color: $max-color;
    }
  }

  &__limit-values {
    margin-left: 0.4rem;
    color: $dark;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.4rem;
    padding: 0.5rem 0 0.5rem 0.5rem;
    width: 8rem;
    display: flex;
    align-items: center;
    border-radius: 0.5rem;
    position: relative;

    &:hover,
    &.active {
      background-color: $bg;
    }

    &__max {
      display: block;
      span {
        color: $max-color;
        display: inline-block;
        width: 2.3rem;
      }
    }

    &__min {
      display: block;
      span {
        display: inline-block;
        color: $min-color;
        width: 2.3rem;
      }
    }
  }
}
</style>
